function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{clip-rule:evenodd;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.f{clip-path:url(#c);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M115.55,61,65.48,88.93,14.42,61a4,4,0,1,0-3.84,7l53,29a4,4,0,0,0,3.87,0l52-29a4,4,0,1,0-3.9-7ZM20.62,42.5,65.48,17.11,115.5,46a4,4,0,1,0,4-6.93L67.5,9a4,4,0,0,0-4,0l-53,30a4,4,0,0,0,0,7l53,30a4,4,0,1,0,3.94-7ZM0,63.5H0v-20H0a12.41,12.41,0,0,1,6.3-11.88l53-30a12.5,12.5,0,0,1,12.4.05l52,30A12.5,12.5,0,0,1,130,43.5h0v20h0a12.5,12.5,0,0,1-6.37,11.92l-52,29a12.5,12.5,0,0,1-12.09,0l-53-29A12.5,12.5,0,0,1,0,63.5Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  x: -53.5,
  y: -294.5,
  width: 720,
  height: 512
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M115.55,191,65.48,218.93,14.42,191a4,4,0,1,0-3.84,7l53,29a4,4,0,0,0,3.87,0l52-29a4,4,0,1,0-3.9-7ZM20.62,172.5l44.86-25.39,50,28.86a4,4,0,1,0,4-6.93l-52-30a4,4,0,0,0-4,0l-53,30a4,4,0,0,0,0,7l53,30a4,4,0,1,0,3.94-7ZM0,193.5H0v-20H0a12.41,12.41,0,0,1,6.3-11.88l53-30a12.5,12.5,0,0,1,12.4.05l52,30A12.5,12.5,0,0,1,130,173.5h0v20h0a12.5,12.5,0,0,1-6.37,11.92l-52,29a12.5,12.5,0,0,1-12.09,0l-53-29A12.5,12.5,0,0,1,0,193.5Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "stackbit-logo-transparent-bg");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "c"
}, /*#__PURE__*/React.createElement("g", {
  className: "d"
}, /*#__PURE__*/React.createElement("rect", {
  className: "e",
  x: -2.5,
  y: -2.5,
  width: 135,
  height: 111
})));

var SvgStackbitLogo = function SvgStackbitLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 130 106",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStackbitLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stackbit-logo.cf41c72c.svg";
export { ForwardRef as ReactComponent };